import React from 'react';
import DidYouKnowCard from './DidYouKnowCard';

const facts = [
  {
    image: "https://i.ibb.co/XJkC5Fh/fact1.webp",
    alt: "Pølser på grillen"
  },
  {
    image: "https://i.ibb.co/0M8fkZP/fact2.webp",
    alt: "Original hotdog"
  },
  {
    image: "https://i.ibb.co/YPXnJVt/fact3.webp",
    alt: "Million hotdogs"
  }
];

export default function DidYouKnowSection() {
  return (
    <section className="relative py-24 bg-white overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid md:grid-cols-3 gap-8">
          {facts.map((fact, index) => (
            <DidYouKnowCard
              key={index}
              {...fact}
              index={index}
            />
          ))}
        </div>
        <p className="text-center font-medium text-lg text-red-600 mt-8">
          Kom og smag selv – vi har noget til alle! 🌭✨
        </p>
      </div>
    </section>
  );
}